export default class LigarOpPedido{
    idsOps: number[];
    idItemPedido: number | null;
    
    constructor(
        idsOps: number[] = [],
        idItemPedido: number = 0
    ){
        this.idsOps = idsOps;
        this.idItemPedido = idItemPedido;
    }
}